import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewListIcon from '@mui/icons-material/ViewList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
  CircularProgress,
  Alert,
  Chip,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import React, { useState, useEffect } from 'react';
import axios from '../../utils/axiosInstance'; // 경로 확인 필요

// dayjs 한국어 설정
dayjs.locale('ko');

// 현재 로그인한 사용자 정보 가져오기
const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

const darkModeStyles = {
  container: {
    p: 2,
    background: 'linear-gradient(180deg, rgba(25,25,38,0.95) 0%, rgba(25,32,48,0.95) 100%)',
    minHeight: '100vh',
  },
  paper: {
    p: 3,
    background: 'linear-gradient(145deg, rgba(35,35,50,0.9) 0%, rgba(35,45,65,0.85) 100%)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    backdropFilter: 'blur(8px)',
  },
  title: {
    color: '#fff',
    fontSize: '28px',
    fontWeight: 'bold',
    mb: 4,
    letterSpacing: '0.5px',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  textField: {
    '& .MuiInputBase-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '8px',
      color: '#fff',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.15)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#60a5fa',
    },
  },
  formControl: {
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '8px',
      color: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.15)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  adminChip: {
    backgroundColor: 'rgba(239, 68, 68, 0.2)',
    color: '#ef4444',
    border: '1px solid rgba(239, 68, 68, 0.5)',
    fontWeight: 'bold',
    marginLeft: 2,
  },
  agentChip: {
    backgroundColor: 'rgba(16, 185, 129, 0.2)',
    color: '#10b981',
    border: '1px solid rgba(16, 185, 129, 0.5)',
    fontWeight: 'bold',
    marginLeft: 2,
  },
  datePickerTextField: {
    '& .MuiInputBase-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      color: '#fff',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.15)',
    },
    '& .MuiSvgIcon-root': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  searchButton: {
    backgroundColor: '#60a5fa',
    color: '#fff',
    borderRadius: '10px',
    padding: '10px 24px',
    boxShadow: '0 4px 10px rgba(33, 150, 243, 0.3)',
    fontWeight: 'bold',
    textTransform: 'none',
    minWidth: '120px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#3b82f6',
      boxShadow: '0 6px 12px rgba(30, 136, 229, 0.4)',
      transform: 'translateY(-2px)',
    },
  },
  exportButton: {
    backgroundColor: '#10b981',
    color: '#fff',
    borderRadius: '10px',
    padding: '10px 24px',
    boxShadow: '0 4px 10px rgba(16, 185, 129, 0.3)',
    fontWeight: 'bold',
    textTransform: 'none',
    minWidth: '120px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#059669',
      boxShadow: '0 6px 12px rgba(5, 150, 105, 0.4)',
      transform: 'translateY(-2px)',
    },
  },
  tableContainer: {
    overflowX: 'auto',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },
  tableHead: {
    backgroundColor: 'rgba(45, 45, 65, 0.9)',
    '& .MuiTableCell-head': {
      color: '#fff',
      fontWeight: 'bold',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
    },
    '&:nth-of-type(even)': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      transition: 'background-color 0.3s ease',
    },
    '& .MuiTableCell-body': {
      color: '#fff',
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
  },
  tableCell: {
    color: '#fff',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
  },
  tablePagination: {
    marginTop: '12px',
    borderRadius: '12px',
    backgroundColor: 'rgba(45, 45, 65, 0.8)',
    color: '#fff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    '& .MuiTablePagination-toolbar': {
      justifyContent: 'center',
    },
    '& .MuiTablePagination-select': {
      padding: '6px 10px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      color: '#fff',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
      '& .MuiSelect-icon': {
        color: 'rgba(255, 255, 255, 0.7)',
      },
    },
    '& .MuiTablePagination-actions': {
      color: '#fff',
      '& .MuiIconButton-root': {
        color: 'rgba(255, 255, 255, 0.7)',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
        '&.Mui-disabled': {
          color: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  errorAlert: {
    backgroundColor: 'rgba(239, 68, 68, 0.2)',
    color: '#ef4444',
    marginBottom: '20px',
    '& .MuiAlert-icon': {
      color: '#ef4444',
    },
  },
};

// 커스텀 날짜/시간 입력 컴포넌트
const CustomDateTimePicker = ({ label, value, onChange }) => {
  return (
    <DateTimePicker
      label={label}
      value={value}
      onChange={onChange}
      format="YYYY-MM-DD HH:mm:ss"
      slotProps={{
        textField: {
          sx: darkModeStyles.datePickerTextField,
        },
        popper: {
          sx: {
            '& .MuiPaper-root': {
              backgroundColor: 'rgba(35, 35, 50, 0.95)',
              color: '#fff',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              '& .MuiPickersDay-root': {
                color: '#fff',
                '&.Mui-selected': {
                  backgroundColor: '#60a5fa',
                  color: '#fff',
                },
                '&:hover': {
                  backgroundColor: 'rgba(96, 165, 250, 0.2)',
                },
              },
              '& .MuiDayCalendar-weekDayLabel': {
                color: 'rgba(255, 255, 255, 0.7)',
              },
              '& .MuiPickersCalendarHeader-label': {
                color: '#fff',
              },
              '& .MuiIconButton-root': {
                color: '#fff',
              },
            },
          },
        },
      }}
    />
  );
};

const ErrorLogs = () => {
  const isNonMobile = useMediaQuery('(min-width:600px)');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // 로그인한 사용자 정보와 권한 가져오기
  const currentUser = getUser();
  const [userGrade, setUserGrade] = useState(currentUser?.grade || 'agent'); 
  const [userPrefix, setUserPrefix] = useState(currentUser?.prefix || '');
  
  // 필터 상태
  const [filters, setFilters] = useState({
    connection: '',
    exception: '',
    ip: '',
    prefix: currentUser?.grade === 'admin' ? '' : currentUser?.prefix || '', // 프리픽스 필터 추가
    startDate: dayjs().startOf('day'),
    endDate: dayjs().endOf('day'),
  });

  // 데이터 상태
  const [errorLogs, setErrorLogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // 상세 정보 다이얼로그 상태
  const [selectedLog, setSelectedLog] = useState(null);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);

  // 페이지 로드시 데이터 조회
  useEffect(() => {
    // 사용자 정보 확인 및 업데이트
    const currentUser = getUser();
    
    if (currentUser) {
      setUserGrade(currentUser.grade || 'agent');
      setUserPrefix(currentUser.prefix || '');
      
      // 에이전트인 경우 자신의 prefix 설정 (변경 불가)
      if (currentUser.grade !== 'admin' && currentUser.prefix) {
        setFilters(prev => ({
          ...prev,
          prefix: currentUser.prefix
        }));
      }
    }  
    fetchErrorLogs();
  }, [page, rowsPerPage]);

  const handleFilterChange = (field, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const fetchErrorLogs = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // API 요청 파라미터 (prefix 필드 추가)
      const params = {
        connection: filters.connection,
        exception: filters.exception,
        ip: filters.ip,
        prefix: filters.prefix, // prefix 필드 추가
        start_date: filters.startDate.format('YYYY-MM-DD'),
        start_time: filters.startDate.format('HH:mm:ss'),
        end_date: filters.endDate.format('YYYY-MM-DD'),
        end_time: filters.endDate.format('HH:mm:ss'),
        page: page + 1,
        per_page: rowsPerPage,
      };
      
      // API 호출
      const response = await axios.get('/error/logs', { params });
      
      if (response.data.status === 'success') {
        setErrorLogs(response.data.data);
        setTotalCount(response.data.total);
        
        // 사용자 권한 설정
        if (response.data.user_grade) {
          setUserGrade(response.data.user_grade);
        }
        
        // 사용자 prefix 설정
        if (response.data.user_prefix) {
          setUserPrefix(response.data.user_prefix);
        }
      } else {
        setError('데이터를 불러오는데 실패했습니다: ' + (response.data.message || '알 수 없는 오류'));
      }
    } catch (err) {
      console.error('에러 로그 조회 중 오류 발생:', err);
      setError('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setPage(0); // 검색 시 첫 페이지로 리셋
    fetchErrorLogs();
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const params = {
        connection: filters.connection,
        exception: filters.exception,
        ip: filters.ip,
        prefix: filters.prefix, // prefix 필드 추가
        start_date: filters.startDate.format('YYYY-MM-DD'),
        start_time: filters.startDate.format('HH:mm:ss'),
        end_date: filters.endDate.format('YYYY-MM-DD'),
        end_time: filters.endDate.format('HH:mm:ss'),
      };
      
      // API 호출
      const response = await axios.get('/error/logs/export', {
        params,
        responseType: 'blob',
      });
      
      // CSV 파일 다운로드
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `error_logs_${dayjs().format('YYYYMMDD_HHmmss')}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error('에러 로그 내보내기 중 오류 발생:', err);
      setError('파일 내보내기 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = async (id) => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await axios.get(`/error/logs/${id}`);
      
      if (response.data.status === 'success') {
        setSelectedLog(response.data.data);
        setDetailDialogOpen(true);
      } else {
        setError('로그 상세 정보를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      console.error('상세 정보 조회 중 오류 발생:', err);
      setError('상세 정보를 불러오는 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteLog = async (id) => {
    // 사용자 권한 확인 - localStorage에서 가져온 정보 사용
    const currentUser = getUser();
    const isAdmin = currentUser?.grade === 'admin';
    
    // 관리자가 아니면 삭제 불가
    if (!isAdmin) {
      setError('삭제 권한이 없습니다. 관리자에게 문의하세요.');
      return;
    }
    
    if (window.confirm('이 에러 로그를 삭제하시겠습니까?')) {
      try {
        setLoading(true);
        setError(null);
        
        const response = await axios.delete(`/error/logs/${id}`);
        
        if (response.data.status === 'success') {
          // 삭제 후 목록 다시 조회
          fetchErrorLogs();
          if (detailDialogOpen && selectedLog?.id === id) {
            setDetailDialogOpen(false);
          }
        } else {
          setError('로그 삭제에 실패했습니다: ' + (response.data.message || ''));
        }
      } catch (err) {
        console.error('에러 로그 삭제 중 오류 발생:', err);
        setError('로그 삭제 중 오류가 발생했습니다: ' + (err.response?.data?.message || '알 수 없는 오류'));
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // 페이지 변경 시 자동으로 fetchErrorLogs()가 호출됨 (useEffect 의존성 배열에 page가 있음)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    // 페이지당 행 수 변경 시 자동으로 fetchErrorLogs()가 호출됨 (useEffect 의존성 배열에 rowsPerPage가 있음)
  };

  // JSON 데이터 포맷팅
  const formatJson = (jsonData) => {
    try {
      if (typeof jsonData === 'string') {
        return JSON.stringify(JSON.parse(jsonData), null, 2);
      }
      return JSON.stringify(jsonData, null, 2);
    } catch (e) {
      return jsonData;
    }
  };

  return (
    <Box sx={darkModeStyles.container}>
      <Paper sx={darkModeStyles.paper}>
        <Box display="flex" alignItems="center" mb={3}>
          <Typography variant="h5" sx={darkModeStyles.title}>
            API 에러 로그
          </Typography>
          
          {/* 사용자 권한 표시 */}
          <Chip 
            label={userGrade === 'admin' ? '관리자' : '에이전트'} 
            sx={userGrade === 'admin' ? darkModeStyles.adminChip : darkModeStyles.agentChip}
            size="small"
          />
          
          {/* 사용자 prefix 표시 (prefix가 있는 경우) */}
          {userPrefix && (
            <Chip 
              label={`Prefix: ${userPrefix}`} 
              sx={{
                backgroundColor: 'rgba(96, 165, 250, 0.2)',
                color: '#60a5fa',
                border: '1px solid rgba(96, 165, 250, 0.5)',
                fontWeight: 'bold',
                marginLeft: 2,
              }}
              size="small"
            />
          )}
        </Box>

        {/* 에러 메시지 표시 */}
        {error && (
          <Alert severity="error" sx={darkModeStyles.errorAlert}>
            {error}
          </Alert>
        )}

        {/* 검색 필터 */}
        <Box display="flex" flexDirection={isNonMobile ? 'row' : 'column'} gap={2} sx={{ mb: 3 }}>
          <TextField
            label="IP 주소"
            value={filters.ip}
            onChange={(e) => handleFilterChange('ip', e.target.value)}
            fullWidth
            sx={darkModeStyles.textField}
          />

          <TextField
            label="에러 메시지"
            value={filters.exception}
            onChange={(e) => handleFilterChange('exception', e.target.value)}
            fullWidth
            sx={darkModeStyles.textField}
          />

          {/* 관리자만 prefix 검색 필드 표시 */}
          {userGrade === 'admin' && (
            <TextField
              label="프리픽스"
              value={filters.prefix}
              onChange={(e) => handleFilterChange('prefix', e.target.value)}
              fullWidth
              sx={darkModeStyles.textField}
            />
          )}

          <FormControl fullWidth sx={darkModeStyles.formControl}>
            <InputLabel>API 연결 타입</InputLabel>
            <Select
              value={filters.connection}
              onChange={(e) => handleFilterChange('connection', e.target.value)}
              label="API 연결 타입"
              MenuProps={{
                PaperProps: {
                  sx: {
                    bgcolor: 'rgba(35, 35, 50, 0.95)',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
                  },
                },
              }}
            >
              <MenuItem value="" sx={darkModeStyles.menuItem}>전체</MenuItem>
              <MenuItem value="api_authentication" sx={darkModeStyles.menuItem}>API 인증</MenuItem>
              <MenuItem value="game_api" sx={darkModeStyles.menuItem}>게임 API</MenuItem>
              <MenuItem value="payment_api" sx={darkModeStyles.menuItem}>결제 API</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box display="flex" flexDirection={isNonMobile ? 'row' : 'column'} gap={2} alignItems={isNonMobile ? 'flex-end' : 'stretch'} sx={{ mb: 3 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ flex: 1, display: 'flex', gap: 2, flexDirection: isNonMobile ? 'row' : 'column' }}>
              <CustomDateTimePicker
                label="시작 날짜 및 시간"
                value={filters.startDate}
                onChange={(date) => handleFilterChange('startDate', date)}
              />
              <CustomDateTimePicker
                label="종료 날짜 및 시간"
                value={filters.endDate}
                onChange={(date) => handleFilterChange('endDate', date)}
              />
            </Box>
          </LocalizationProvider>

          <Box display="flex" gap={2} flexDirection={isNonMobile ? 'row' : 'column'}>
            <Button
              variant="contained"
              onClick={handleSearch}
              startIcon={<SearchIcon />}
              sx={darkModeStyles.searchButton}
            >
              검색
            </Button>
            <Button
              variant="contained"
              onClick={handleExport}
              startIcon={<FileDownloadIcon />}
              sx={darkModeStyles.exportButton}
            >
              내보내기
            </Button>
          </Box>
        </Box>

        {/* 테이블 영역 */}
        <TableContainer sx={darkModeStyles.tableContainer}>
          <Table stickyHeader>
            <TableHead sx={darkModeStyles.tableHead}>
              <TableRow>
                <TableCell sx={darkModeStyles.tableCell}>ID</TableCell>
                <TableCell sx={darkModeStyles.tableCell}>프리픽스</TableCell>
                <TableCell sx={darkModeStyles.tableCell}>연결 타입</TableCell>
                <TableCell sx={darkModeStyles.tableCell}>IP 주소</TableCell>
                <TableCell sx={darkModeStyles.tableCell}>에러 메시지</TableCell>
                <TableCell sx={darkModeStyles.tableCell}>일시</TableCell>
                <TableCell sx={darkModeStyles.tableCell}>작업</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell 
                    colSpan={7} 
                    align="center" 
                    sx={{ padding: '30px 0' }}
                  >
                    <CircularProgress sx={{ color: '#60a5fa' }} />
                  </TableCell>
                </TableRow>
              ) : errorLogs.length > 0 ? (
                errorLogs.map((log) => (
                  <TableRow key={log.id} sx={darkModeStyles.tableRow}>
                    <TableCell sx={darkModeStyles.tableCell}>{log.id}</TableCell>
                    <TableCell sx={darkModeStyles.tableCell}>{log.prefix || 'NULL'}</TableCell>
                    <TableCell sx={darkModeStyles.tableCell}>{log.connection}</TableCell>
                    <TableCell sx={darkModeStyles.tableCell}>{log.ip}</TableCell>
                    <TableCell sx={darkModeStyles.tableCell}>
                      {log.exception && log.exception.length > 50 
                        ? `${log.exception.substring(0, 50)}...` 
                        : log.exception}
                    </TableCell>
                    <TableCell sx={darkModeStyles.tableCell}>
                      {dayjs(log.failed_at).format('YYYY-MM-DD HH:mm:ss')}
                    </TableCell>
                    <TableCell sx={darkModeStyles.tableCell}>
                      <Box display="flex" justifyContent="center">
                        <Tooltip title="상세 보기">
                          <IconButton 
                            size="small" 
                            onClick={() => handleViewDetails(log.id)}
                            sx={{ 
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                              color: '#fff',
                              margin: '0 5px',
                              '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              },
                            }}
                          >
                            <ViewListIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {/* 관리자만 삭제 버튼 표시 */}
                        {userGrade === 'admin' && (
                          <Tooltip title="삭제">
                            <IconButton 
                              size="small" 
                              onClick={() => handleDeleteLog(log.id)}
                              sx={{ 
                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                color: '#ef4444',
                                margin: '0 5px',
                                '&:hover': {
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell 
                    colSpan={7} 
                    align="center" 
                    sx={{ 
                      color: 'rgba(255, 255, 255, 0.7)',
                      fontStyle: 'italic',
                      padding: '40px 0',
                    }}
                  >
                    데이터가 없습니다.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* 페이지네이션 */}
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="페이지당 행 수"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count !== -1 ? count : `${to} 이상`}`}
          sx={darkModeStyles.tablePagination}
        />

        {/* 상세 정보 다이얼로그 */}
        <Dialog 
          open={detailDialogOpen} 
          onClose={() => setDetailDialogOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: 'rgba(35, 35, 50, 0.95)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
              borderRadius: '16px',
            }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: 'rgba(35, 35, 50, 0.95)',
            color: '#fff',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          }}>
            에러 로그 상세 정보
          </DialogTitle>
          <DialogContent sx={{ 
            backgroundColor: 'rgba(35, 35, 50, 0.95)',
            color: '#fff',
            padding: '20px',
          }}>
            {selectedLog && (
              <Box sx={{ mt: 2 }}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 1 }}>
                    기본 정보
                  </Typography>
                  <Box sx={{ 
                    p: 2, 
                    backgroundColor: 'rgba(0, 0, 0, 0.2)', 
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                  }}>
                    <Typography sx={{ mb: 1 }}>
                      <strong>ID:</strong> {selectedLog.id}
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                      <strong>UUID:</strong> {selectedLog.uuid}
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                      <strong>프리픽스:</strong> {selectedLog.prefix || 'NULL'}
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                      <strong>연결 유형:</strong> {selectedLog.connection}
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                      <strong>큐:</strong> {selectedLog.queue}
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                      <strong>IP 주소:</strong> {selectedLog.ip}
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                      <strong>발생 시각:</strong> {dayjs(selectedLog.failed_at).format('YYYY-MM-DD HH:mm:ss')}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 1 }}>
                    에러 메시지
                  </Typography>
                  <Box sx={{ 
                    p: 2, 
                    backgroundColor: 'rgba(239, 68, 68, 0.1)', 
                    borderRadius: '8px',
                    border: '1px solid rgba(239, 68, 68, 0.3)',
                    whiteSpace: 'pre-wrap',
                    maxHeight: '150px',
                    overflowY: 'auto',
                  }}>
                    <Typography sx={{ color: '#ef4444' }}>
                      {selectedLog.exception}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 1 }}>
                    페이로드 데이터
                  </Typography>
                  <Box sx={{ 
                    p: 2, 
                    backgroundColor: 'rgba(0, 0, 0, 0.2)', 
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                  }}>
                    <Box 
                      component="pre" 
                      sx={{ 
                        whiteSpace: 'pre-wrap',
                        maxHeight: '300px',
                        overflowY: 'auto',
                        fontFamily: 'monospace',
                        fontSize: '12px',
                        color: '#60a5fa',
                        m: 0,
                      }}
                    >
                      {formatJson(selectedLog.payload)}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ 
            backgroundColor: 'rgba(35, 35, 50, 0.95)',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            padding: '16px',
          }}>
            <Button onClick={() => setDetailDialogOpen(false)} sx={{ color: '#fff' }}>
              닫기
            </Button>
            {/* 관리자만 삭제 버튼 표시 */}
            {userGrade === 'admin' && selectedLog && (
              <Button 
                onClick={() => handleDeleteLog(selectedLog.id)} 
                sx={{ color: '#ef4444' }}
              >
                삭제
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
};

export default ErrorLogs;